import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3tzh9mjdm6: FaireBrandEntity = {
  token: "b_3tzh9mjdm6",
  type: "brand",
  name: "Flânerie by MAIQ",
  avatarUrl:
    "https://cdn.faire.com/fastly/b042aed483cfc13a191e9f0babbef31b1f7747a8362cc6802478ad840edf9c10.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/288b3ffc7b4ba464d12e10dbeaedb697ee35107d5c7bcd0f178e755c05fa5d87.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b042aed483cfc13a191e9f0babbef31b1f7747a8362cc6802478ad840edf9c10.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/288b3ffc7b4ba464d12e10dbeaedb697ee35107d5c7bcd0f178e755c05fa5d87.jpeg",
  location: "Sacramento, CA, USA",
  minimumOrderDollars: 80,
  rating: 4.9,
  reviewCount: 354,
  isTopShop: true,
  isInsider: true,
  description:
    "Flânerie by MAIQ welcomes you to a curated world of small-batch, bohemian, vintage, and minimalist jewelry styles. We carry a large collection of handmade, non-tarnish, hypoallergenic pieces that stand out in your boutique. Explore earrings, necklaces, rings, bracelets, and more, each meticulously crafted from premium materials like 18K gold plating, freshwater pearls, sterling silver, and semi-precious stones. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:18.759Z",
    importedBy: "entity-db-cli",
  },
};
